import {
    onCLS,
    onFID,
    onLCP,
    onINP,
} from 'web-vitals';
import trackingService from './tracking';

const { coreWebVitals } = trackingService;
const coreWebVitalsTrack = coreWebVitals.bind(trackingService);
const trackProxy = (options) => coreWebVitalsTrack({
    ...options,
    source: 'whitelabel',
});

onCLS(trackProxy);
onFID(trackProxy);
onLCP(trackProxy);
onINP(trackProxy);
